import { type FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Space, Text } from '@g2u/ui-kit';

import { type WithOptionalDataTest } from 'types';
import { useText } from 'helpers/hooks/useText';
import { Section } from 'components';

type Props = WithOptionalDataTest;

export const Greeting: FC<Props> = observer(() => {
  const { getText } = useText();
  return (
    <Section title="Greeting">
      <Space.$ direction={Space.Direction.Vertical} className="script-box">
        <Text.$ mark size={Text.Size.SM}>
          {getText('booking.start.initialGreeting')}
        </Text.$>
        <Text.$ size={Text.Size.SM}>{getText('booking.start.followUp')}</Text.$>
        <Text.$ size={Text.Size.SM} type="secondary" italic>
          *Always acknowledge their response*
        </Text.$>
      </Space.$>
    </Section>
  );
});
